const analyticsConfig = {
	posthogKey: process.env.REACT_APP_POSTHOG_KEY,
	posthogHost: process.env.REACT_APP_POSTHOG_HOST
}

export default analyticsConfig
